// Nguồn khách hàng: giá trị chọn sẵn; ngoài ra cho nhập tay (lưu nguyên chữ đã nhập)
export const customerSourceOptions: { label: string; value: string }[] = [
  { value: "SEO", label: "SEO" },
  { value: "HOTLINE", label: "Hotline" },
  { value: "ZALO", label: "Zalo" },
  { value: "FACEBOOK", label: "Facebook" },
  { value: "SEMINAR", label: "Hội thảo" },
  { value: "SALE_NETWORK", label: "Mối quan hệ SALE" },
];

// Ngành nghề kinh doanh: danh sách chọn sẵn; ngoài ra cho nhập tay (lưu nguyên chữ đã nhập)
export const customerIndustryOptions: { label: string; value: string }[] = [
  "Sản xuất",
  "Thương mại",
  "Vận tải – Logistics",
  "Giáo dục",
  "Thực phẩm – Đồ uống",
  "Xây dựng",
  "Công nghệ",
  "Y tế – Dược",
  "Dịch vụ",
  "Khác",
].map((value) => ({ value, label: value }));

// Màu chip của tag: cố định theo tên để cùng 1 tag luôn cùng màu
const tagColors = ["blue", "green", "orange", "purple", "cyan", "magenta", "gold", "geekblue", "volcano", "lime"];

export const getCustomerTagColor = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return tagColors[hash % tagColors.length];
};

export const getCustomerSourceLabel = (source?: string | null) => {
  const value = source?.trim();
  if (!value) return "";
  return customerSourceOptions.find((option) => option.value === value)?.label || value;
};
